import { IAuthApi, IAuthPlugin, AuthService } from "shared/mechanics/auth";

import { IPlugin } from "shared/mechanics/plugin";

const clientId = process.env.REACT_APP_INTEGRATION_VKONTAKTE_AUTH_CLIENT_ID!;
const redirectUrl = `${window.location.origin}/auth/signin`;

export class VKontakteAuthPlugin implements IPlugin, IAuthPlugin {
	name: string = "Vkontakte Auth";
	displayName: string = "ВКонтакте";

	init(): void {
		const windowWithVKontakteAuthCallback = window.opener as WindowWithVKontakteAuthCallback;
		if (windowWithVKontakteAuthCallback && windowWithVKontakteAuthCallback.vkontakteAuthCallbacks) {
			processAuthResponse(windowWithVKontakteAuthCallback.vkontakteAuthCallbacks);
		}
	}

	async useAuthentication(): Promise<IAuthApi> {
		const authApi: IAuthApi = {
			signIn: async () => {
				const { code } = await resolveVKontakteToken();

				await AuthService.signInVkontatke(code, redirectUrl);
			}
		}

		return Promise.resolve<IAuthApi>(authApi);
	}
};

interface WindowWithVKontakteAuthCallback {
	vkontakteAuthCallbacks?: VKontakteAuthCallback;
}
interface VKontakteAuthCallback {
	onSuccess: (code: string) => void;
	onFailed: (reason: string) => void;
}

async function resolveVKontakteToken(): Promise<{ code: string }> {
	return new Promise<{ code: string }>((resolve, reject) => {
		const authUrl = `https://oauth.vk.com/authorize?client_id=${clientId}&display=popup&response_type=code&redirect_uri=${redirectUrl}&scope=email&v=5.131&state=vk&revoke=1`;
		document.open(authUrl, 'Yandex Auth', 'popup');

		(window as WindowWithVKontakteAuthCallback).vkontakteAuthCallbacks = {
			onSuccess: (code) => resolve({ code }),
			onFailed: (reason) => reject(reason)
		}
	});
}

function processAuthResponse(callbacks: VKontakteAuthCallback) {
	const state = searchInQueryString('state');
	if (!state || state !== 'vk')
		return;

	const error = searchInQueryString('error');
	if (error != null) {
		callbacks.onFailed(searchInQueryString('error_reason') || 'unknown');
		window.close();
		return;
	}

	const code = searchInQueryString('code');
	if (!code) {
		callbacks.onFailed('no code');
		window.close();
		return;
	}

	callbacks.onSuccess(code)
	window.close();
}

function searchInQueryString(key: string): string | null {
	const searchRegex = new RegExp(`${key}=([^&]+)`);
	const searchResult = searchRegex.exec(document.location.search || '');
	if (!searchResult)
		return null;
	if (!searchResult[1])
		return null;

	return searchResult[1];
}